import React from 'react'
import { Box, Dialog, DialogActions, DialogContent, DialogTitle, Stack } from '@mui/material'

import { Button, Icon, IconButton, Typography } from '~components/internal'
import { borderRadius, colors, spacing, typography } from '~tokens/internal'

import { formatRemaining } from './formatRemaining'

interface SessionExpiryDialogProps {
  open: boolean
  remainingMs: number
  onDismiss: () => void
  onSignOutNow: () => void
}

const SessionExpiryDialog: React.FC<SessionExpiryDialogProps> = ({
  open,
  remainingMs,
  onDismiss,
  onSignOutNow,
}) => {
  return (
    <Dialog open={open} onClose={onDismiss} maxWidth='xs' fullWidth>
      <DialogTitle sx={{ display: 'flex', alignItems: 'center', gap: spacing.xxs }}>
        <Box
          sx={{
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
            flexShrink: 0,
            width: 32,
            height: 32,
            borderRadius: borderRadius.full,
            backgroundColor: colors.orange[100],
            color: colors.orange[600],
          }}
        >
          <Icon name='warning' size={typography.fontSize.lg} />
        </Box>
        <Typography variant='h6' sx={{ flex: 1, fontWeight: typography.fontWeight.semibold }}>
          Your session is about to expire
        </Typography>
        <IconButton size='small' aria-label='Dismiss' onClick={onDismiss}>
          <Icon name='close' size={typography.fontSize.md} />
        </IconButton>
      </DialogTitle>
      <DialogContent>
        <Typography variant='body1'>
          You&rsquo;ll be automatically signed out in{' '}
          <Box component='span' sx={{ fontWeight: typography.fontWeight.bold }}>
            {formatRemaining(remainingMs)}
          </Box>
          . Any unsaved work on this page will be preserved and restored after you sign back in.
        </Typography>
      </DialogContent>
      <DialogActions>
        <Stack
          direction='row'
          spacing={spacing.xxs}
          sx={{ justifyContent: 'flex-end', width: '100%' }}
        >
          <Button variant='outlined' onClick={onDismiss}>
            Sign Out Later
          </Button>
          <Button variant='contained' onClick={onSignOutNow}>
            Sign Out Now
          </Button>
        </Stack>
      </DialogActions>
    </Dialog>
  )
}

export default SessionExpiryDialog
